module.exports = __webpack_public_path__ + "static/img/wedding_banner_bg.6b5277a.png";